import { fetchGet, fetchPost, fetchPatch, fetchDelete } from "./util";

export const getUsers = ({results, columns, offset, filter, sort}) => {
    return fetchGet(`/users?results=${results}&columns=${columns}&offset=${offset}${filter}${sort}`).then((res) => res);
}
export const getUsersList = () => {
  return fetchGet(`/capabilities/salesrep`).then((res) => res);
};

export const getUserDetails = (id) => {
  return fetchGet(`/users/${id}/profile`).then((res) => res);
};

export const updateUser = ({id, obj}) => {
  return fetchPatch(`/users/${id}/profile`, obj).then((res) => res);
};

export const getUserTeamHistory = (id) => {
  return fetchGet(`/users/${id}/team-history`).then((res) => res);
};

export const addTeamTransition = ({id, obj}) => {
  return fetchPost(`/users/${id}/team-history`, obj).then((res) => res);
};

export const editTeamTransition = ({id, historyId, obj}) => {
  return fetchPatch(`/users/${id}/team-history/${historyId}`, obj).then((res) => res);
};

export const updateTeam = (data) => {
  return fetchPatch(`/teams/${data.id}`, data.obj).then((res) => res);
};

export const createUser = (data) => {
  return fetchPost(`/users`, data.formData).then((res) => res);
};

export const addTeam = (data) => {
  return fetchPost(`/teams`, data).then((res) => res);
};

export const getTeams = (data) => {
  const showDeleted = data && data.showDeleted ? `?show_deleted=1` : ``;
  return fetchGet(`/teams${showDeleted}`).then((res) => res);
};

export const deleteTeam = (obj) => {
  return fetchDelete(`/teams/${obj.id}`, {}).then(res => res);
}

export const restoreTeam = (obj) => {
  return fetchPatch(`/teams/${obj.id}/restore`, {}).then(res => res);
}

export const getCaseTeams = () => {
  return fetchGet(`/teams/list`).then((res) => res);
}

export const getTeamDetails = (data) => {
  return fetchPost(`/teams/hierarchy`,data).then(res => res);
}

export const getActiveTeamUsers = (data) => {
  return fetchGet(`/users/active?${data}`).then(res => res);
}

export const getActiveUsers = () => {
  return fetchGet(`/users/active`).then(res => res);
}